import { render, staticRenderFns } from "./autoRules.vue?vue&type=template&id=1b7ccc09&scoped=true"
import script from "./autoRules.vue?vue&type=script&lang=js"
export * from "./autoRules.vue?vue&type=script&lang=js"
import style0 from "./autoRules.vue?vue&type=style&index=0&id=1b7ccc09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7ccc09",
  null
  
)

export default component.exports